import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-cancelled-inquiry",
  "use": "notification-cancelled-inquiry-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"notification-cancelled-inquiry\">\n  <path fill-rule=\"evenodd\" d=\"M573.5,268.486l-2,2-2-2a0.709,0.709,0,1,0-1,1l2,2-2,2a0.709,0.709,0,1,0,1,1l2-2,2,2a0.709,0.709,0,0,0,1-1l-2-2,2-2A0.709,0.709,0,0,0,573.5,268.486Zm-2,11.507a8.5,8.5,0,1,1,8.5-8.5A8.51,8.51,0,0,1,571.5,279.993Zm0-15.586a7.085,7.085,0,1,0,7.085,7.084A7.093,7.093,0,0,0,571.5,264.407Z\" transform=\"translate(-563 -263)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-cancelled-inquiry.svg
// module id = null
// module chunks = 